import { PageHeader } from 'antd';
import React from 'react'
import { connect } from 'react-redux';
import { openDrawer } from '../actions/Drawer';
import AlertsList from '../components/AlertsList';

class Alerts extends React.Component {
    render() {
        document.title = 'Alerts | Smart4City';
        return (
            <div>
                <PageHeader
                    title="Alerty"
                    subTitle="seznam všech alertů"
                    extra={[]}
                >
                    <AlertsList />
                </PageHeader>
            </div>
        )
    }
}
const mapStateToProps = state => ({
});

export default connect(
    mapStateToProps,
    { openDrawer }
)(Alerts)
